import { useEffect, useState } from "react";
import { X, Check } from "lucide-react";
import { APP_URL } from "@/lib/constants";

const PERKS = [
  "Полный каталог итальянской верхней одежды",
  "10 000 ₸ на счёт сразу после регистрации",
  "Виртуальная ИИ-примерка",
  "До 60 000 ₸ в подарок ко Дню рождения",
];

export const AccessPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("ang_popup_shown")) return;

    const trigger = () => {
      if (sessionStorage.getItem("ang_popup_shown")) return;
      sessionStorage.setItem("ang_popup_shown", "1");
      setOpen(true);
    };

    const faq = document.getElementById("faq");
    let io;
    if (faq) {
      io = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            trigger();
            io.disconnect();
          }
        },
        { threshold: 0.4 }
      );
      io.observe(faq);
    }
    const timer = setTimeout(trigger, 60000);
    return () => {
      io && io.disconnect();
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      data-testid="access-popup-overlay"
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 popup-overlay"
      style={{ background: "rgba(6,4,10,0.7)", backdropFilter: "blur(6px)" }}
      onClick={() => setOpen(false)}
    >
      <div
        data-testid="access-popup"
        className="popup-card relative w-full max-w-md rounded-3xl overflow-hidden"
        style={{ background: "var(--ink)", border: "1px solid rgba(255,171,0,0.35)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="access-popup-close"
          onClick={() => setOpen(false)}
          aria-label="Закрыть"
          className="absolute top-4 right-4 z-10 w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-300 hover:bg-white/10"
          style={{ color: "rgba(255,255,255,0.6)" }}
        >
          <X size={18} />
        </button>

        <div className="flex justify-center pt-8">
          <img src="/media/vip-gift.png" alt="" className="w-36 h-36 object-contain popup-gift" />
        </div>

        <div className="px-8 pb-8 pt-4 text-center">
          <span className="pw-eyebrow !text-white/50 justify-center">Angiolini VIP</span>
          <h3
            className="mt-4 text-white font-semibold"
            style={{ fontSize: "clamp(1.4rem, 3vw, 1.75rem)", letterSpacing: "-0.03em", lineHeight: 1.15 }}
          >
            Ваш доступ к итальянскому гардеробу уже готов
          </h3>
          <ul className="mt-6 space-y-3 text-left">
            {PERKS.map((p, i) => (
              <li key={i} className="flex items-start gap-3 text-[14px] text-white/75">
                <Check size={16} strokeWidth={2.5} style={{ color: "var(--accent)" }} className="shrink-0 mt-0.5" />
                {p}
              </li>
            ))}
          </ul>
          <a
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="access-popup-cta"
            className="pw-btn pw-btn-light btn-fill-gold w-full mt-7 !py-4"
            onClick={() => setOpen(false)}
          >
            <span className="fill-inner">
              Получить доступ прямо сейчас
              <span className="fill-arrow" aria-hidden="true">→</span>
            </span>
          </a>
          <button
            data-testid="access-popup-later"
            onClick={() => setOpen(false)}
            className="mt-4 text-[13px] text-white/40 hover:text-white/70 transition-colors duration-300"
          >
            Напомнить позже
          </button>
          <p className="mt-3 text-[11px] text-white/30">Регистрация бесплатна и занимает меньше минуты</p>
        </div>
      </div>
    </div>
  );
};
